import { render, staticRenderFns } from "./ButtonDirection.vue?vue&type=template&id=27f71f19&scoped=true&lang=pug"
import script from "./ButtonDirection.vue?vue&type=script&lang=ts"
export * from "./ButtonDirection.vue?vue&type=script&lang=ts"
import style0 from "./ButtonDirection.vue?vue&type=style&index=0&id=27f71f19&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f71f19",
  null
  
)

export default component.exports